
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-detail-page",
      function () {
        return require("private-next-pages/job-detail-page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-detail-page"])
      });
    }
  